<div class="dialog-padding">
  <h1 mat-dialog-title>Update Reservation Status?</h1>
  <div mat-modal-content>
    <div class="status-wrapper">
      Update status from
      <app-ride-status-chip id="adjustReservationStatusDialog-chip-fromStatus" [status]="reservation?.status"></app-ride-status-chip>
      <mat-icon>arrow_forward</mat-icon>
      <app-ride-status-chip id="adjustReservationStatusDialog-chip-toStatus" [status]="nextStatus"></app-ride-status-chip>
    </div>

    <form [formGroup]="adjustReservationForm">
      <p>New status time ({{ abbreviatedTimezone }})</p>

      <div class="timestamp-wrapper">
        <mat-form-field appearance="outline" class="date-input" (click)="picker.open()">
          <mat-icon matPrefix>calendar_today</mat-icon>
          <input
            id="adjustReservationStatusDialog-input-timestampDate"
            class="date-input"
            matInput
            readonly
            [min]="minDate"
            [max]="maxDate"
            [matDatepicker]="picker"
            placeholder="Choose a date"
            formControlName="timestampDate"
          />
          <mat-datepicker #picker [startAt]="minDate" [disabled]="isDatePickerDisabled()"></mat-datepicker>
        </mat-form-field>
        <mat-form-field appearance="outline" class="time-input">
          <mat-icon matPrefix>access_time</mat-icon>
          <input
            id="adjustReservationStatusDialog-input-timestampTime"
            matInput
            uzTimeInput
            formControlName="timestampTime"
            autocomplete="off"
            [hideClearButton]="true"
          />
        </mat-form-field>
      </div>
      <ng-container *ngIf="adjustReservationForm.get('timestampTime').invalid && adjustReservationForm.get('timestampTime').errors">
        <mat-error *ngFor="let error of getErrors(adjustReservationForm.get('timestampTime').errors)">
          {{ error }}
        </mat-error>
      </ng-container>
    </form>
  </div>
  <div mat-dialog-actions align="end">
    <button id="adjustReservationStatusDialog-button-cancel" type="button" mat-button (click)="closeModal()">Cancel</button>
    <button
      id="adjustReservationStatusDialog-button-update"
      type="button"
      mat-raised-button
      color="primary"
      [disabled]="isSubmitDisabled()"
      (click)="updateReservationStatus()"
    >
      Update
    </button>
  </div>
</div>
